import { AddressPill } from './parts';
import { LinkGlyph, PonsBadge } from './icons';
import { coinDisplayAddress, safeCoinLink } from './coinIdentityModel';
import type { CoinView } from './model';

export function CoinIdentity({
  coin,
  titleId,
  compact = false,
}: {
  coin: CoinView;
  titleId?: string;
  compact?: boolean;
}) {
  const Heading = compact ? 'h3' : 'h2';
  const address = coinDisplayAddress(coin);
  const pairHref = !coin.simulated && safeCoinLink(coin.pairHref ?? undefined);
  return (
    <>
      <div className="coin-title">
        <Heading id={titleId} title={coin.name}>
          {coin.name}
        </Heading>
        <div className="coin-badges">
          {coin.simulated ? (
            <span
              className="coin-badge is-game"
              role="img"
              aria-label="Game token"
              title="Game token"
            >
              <span className="game-badge-label">GAME</span>
            </span>
          ) : (
            coin.links
              .filter((link) => safeCoinLink(link.href))
              .map((link) => (
                <a
                  key={link.label}
                  className="coin-badge"
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={
                    'View ' +
                    coin.name +
                    ' on ' +
                    link.label +
                    ' (opens in a new tab)'
                  }
                >
                  {link.label === 'X' ? (
                    <img
                      src="/images/explore-x.svg"
                      alt=""
                      width={12}
                      height={11}
                    />
                  ) : link.brand === 'pons' ? (
                    <PonsBadge />
                  ) : (
                    <LinkGlyph />
                  )}
                </a>
              ))
          )}
        </div>
      </div>
      <div className="coin-meta">
        <span className="coin-pair">
          <b title={'$' + coin.symbol}>${coin.symbol}</b>
          {coin.pairSymbol && (
            <>
              <LinkGlyph />
              {pairHref ? (
                <a href={pairHref} target="_blank" rel="noopener noreferrer">
                  {coin.pairSymbol}
                </a>
              ) : (
                <span className="preview-pair-name">{coin.pairSymbol}</span>
              )}
            </>
          )}
        </span>
        {address && (
          <AddressPill address={address} simulated={coin.simulated} />
        )}
      </div>
      {coin.simulated && (
        <span className="sr-only">
          Simulated token. Contract address is a test placeholder.
        </span>
      )}
    </>
  );
}
